import { css as i } from "styled-components";
const e = (o) => o.componentColors.multiPanelSection, a = {
  container: {
    base: /* @__PURE__ */ i([
      "position:relative;display:flex;flex-direction:column;z-index:0;box-sizing:border-box;"
    ]),
    childrenWrapper: ({ showContent: o }) => /* @__PURE__ */ i([
      "position:relative;z-index:1;transition:opacity 200ms ease-in 600ms;opacity:",
      ";"
    ], o ? 1 : 0)
  },
  panel: {
    base: ({ theme: o, $elementInFocus: n }) => /* @__PURE__ */ i([
      "box-sizing:border-box;width:100%;position:",
      ";top:0;background-color:",
      ";padding:",
      ";border:0.2rem solid ",
      ";z-index:0;opacity:0;display:none;"
    ], n ? "relative" : "absolute", e(o).panel.background, o.space.sm, e(o).panel.border),
    overlay: /* @__PURE__ */ i([
      "position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;"
    ])
  }
};
export {
  a as default
};
